<template>
    <b-container fluid class="mt--7">
        <b-card :title="title">
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="input-group-first_name"
                        label="First Name:"
                        label-for="input-first_name"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-first_name"
                            readonly
                            v-model="model.first_name"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-last_name"
                        label="Last Name:"
                        label-for="input-last_name"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-last_name"
                            readonly
                            v-model="model.last_name"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-email"
                        label="Email:"
                        label-for="input-email"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-email"
                            readonly
                            v-model="model.email"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="New Password"
                        name="password"
                        label-for="input-new-password"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-new-password"
                            type="password"
                            v-model="model.password"
                        >
                        </b-form-input>
                    </b-form-group>
                    <b-form-group
                        label="Retype Password"
                        type="password"
                        label-for="input-confirm-password"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            type="password"
                            v-model="model.password_confirmation"
                            id="input-confirm-password"
                        ></b-form-input
                    ></b-form-group>

                    <div class="text-right">
                        <b-button
                            class="my-4"
                            variant="primary"
                            :disabled="updating ? true : false"
                            @click="updatePassword"
                            >{{
                                updating
                                    ? 'Changing Password...'
                                    : 'Change Password'
                            }}</b-button
                        >
                    </div>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    name: 'UserProfile',
    mixins: [popupMixins],
    data: () => ({
        title: 'User Profile',
        model: {},
        updating: false,
    }),

    computed: {
        user() {
            return this.$store.state.user
        },
    },

    mounted() {
        const user = this.$store.state.user
        console.log('user', user)
        const { email, first_name, last_name, id } = user
        this.$set(this.model, 'email', email)
        this.$set(this.model, 'first_name', first_name)
        this.$set(this.model, 'last_name', last_name)
        this.$set(this.model, 'id', id)
        console.log('model', this.model)
    },

    methods: {
        async updatePassword() {
            try {
                this.updating = true
                const {
                    id: userId,
                    password,
                    password_confirmation,
                } = this.model

                if (
                    !password ||
                    password.length < 6 ||
                    password != password_confirmation
                )
                    throw new Error('Invalid Password')

                await this.$store.dispatch('users/updatePassword', {
                    userId,
                    password,
                })

                this.doToast('Success!', 'Password Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>